module.exports = __webpack_public_path__ + "media/images/meta/admin/favicon-staging-2c42420907b27abadd26ae9969303ea9.png";